export default __webpack_public_path__ + "static/media/GCP.568073bc.svg";